import { useState, useEffect } from "react";
import { loadRequestIndentNumber } from "../services/requestIndentService";

const useRequestIndentNumber = (editID) => {
    const [requestIndentNumber, setRequestIndentNumber] = useState([]);

    const generateRequestIndentNumberByDepartment = async (departmentID, departmentDescription) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_department: departmentDescription
        };

        try {
            const data = await loadRequestIndentNumber(para);
            if (data && data.length > 0) {
                setRequestIndentNumber(data[0].request_indent_number); // Assumes backend returns `material_code`
            }
        } catch (error) {
            console.error("Failed to generate request_indent_number", error);
        }
    };

    return {
        requestIndentNumber,
        setRequestIndentNumber,
        generateRequestIndentNumberByDepartment,
    };
};

export default useRequestIndentNumber;
